<template>
  <div>
    <!-- <hr /> -->
    <div class="container">
      <div class="row">
        <div class="d-flex col-lg-8 col-md-12 justify-content-end">
          <div class="embed-responsive embed-responsive-21by9">
            <iframe
              class="embed-responsive-item"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15177.69714786074!2d-66.6336701!3d18.0055026!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdf03b8c5289aea5a!2sIMPRENTA%20LAS%20AMERICAS!5e0!3m2!1sen!2sus!4v1587056227538!5m2!1sen!2sus"
              width="600"
              height="400"
              frameborder="0"
              style="border:0;"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <mdb-card-body class="contact text-center h-100 ">
            <h3 class="my-4 pb-2">Contacto</h3>
            <ul class="text-lg-left list-unstyled ml-4">
              <li>
                <p>
                  <mdb-icon icon="map-marker" class="pr-2" />1880 Avenida Las
                  Américas,
                </p>
                <p class="mt-n3 ml-4">Ponce PR, 00728</p>
              </li>
              <li>
                <p><mdb-icon icon="phone" class="pr-2" />787-843-9638</p>
              </li>
              <li>
                <p><mdb-icon icon="phone" class="pr-2" />787-844-7668</p>
              </li>
              <li>
                <p>
                  <mdb-icon
                    icon="envelope"
                    class="pr-2"
                  />imprentalasamericas1@yahoo.com
                </p>
              </li>
            </ul>
            <hr class="hr-light my-4" />
            <ul class="list-inline text-center list-unstyled">
              <li class="list-inline-item">
                <a class="p-2 fa-lg w-ic">
                  <mdb-icon fab icon="facebook" />
                </a>
              </li>
              <li class="list-inline-item">
                <a
                  class="p-2 fa-lg w-ic"
                  href="https://g.page/r/CVrqmijFuAPfEAE"
                  target="_blank"
                >
                  <mdb-icon fab icon="google-plus-g" />
                </a>
              </li>
              <li class="list-inline-item">
                <a class="p-2 fa-lg w-ic">
                  <mdb-icon fab icon="instagram" />
                </a>
              </li>
            </ul>
          </mdb-card-body>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mdbCardBody, mdbIcon } from "mdbvue";
export default {
  components: {
    mdbIcon,
    mdbCardBody,
  },
};
</script>

<style lang="css">
.map-responsive {
  overflow: hidden;
  padding-bottom: 50%;
  position: relative;
  height: 0;
}
.map-responsive iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
